import React from 'react';
import { Props, IDepartamento } from './types';
import { Select } from 'antd';
import { listaDepartamentos } from '../services';
import Justification from '../../Modal/Justification';
import { IModification } from '../../Modal/Justification/types';

const SelectDepartamento: React.FC<Props> = ({ currentDepartamento }): JSX.Element => {
  const [departamentos, setDepartamentos] = React.useState<IDepartamento[]>([]);
  const [open, setOpen] = React.useState<boolean>(false);
  const [modification, setModification] = React.useState<IModification>();

  const handleChang = (e: number): void => {
    setModification({
      departamento: e,
      status: 'ARI',
    });
    setOpen(true);
  };

  const handleClick = (): void => {
    if (departamentos.length > 0) return;
    listaDepartamentos?.listaDepartamentos().then((response) => {
      setDepartamentos(response.data.departamentos);
    });
  };

  return (
    <>
      <Justification open={open} setOpen={setOpen} modification={modification} />

      <Select data-cy="selectDepartment"
        placeholder={
          currentDepartamento ? (
            <span style={{ color: '#555' }}> {currentDepartamento}</span>
          ) : (
            'Selecione um departamento'
          )
        }
        onClick={handleClick}
        onChange={handleChang}
        style={{ width: '100%' }}
        showSearch
        optionFilterProp={'children'}
        filterOption={(input, option) =>
          option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {departamentos?.map((departamento) => (
          <Select.Option value={departamento?.codigo}>{departamento?.descricao}</Select.Option>
        ))}
      </Select>
    </>
  );
};

export default SelectDepartamento;
